import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { get } from "lodash";
import { Button } from "../../../components/Field";
import { resetStore } from "../../../actions/storage";
import Text from "../../../components/Text";
import DialogBox from "../../../components/DialogBox";
import AsyncGet from "../../../components/Materials/AsyncGet";

const Logout = ({ onClose }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    return (
        <DialogBox
            onClose={onClose}
            hasCloseIcon={false}
            title="Logout"
            render={() => {
                return (
                    <Text>Are you sure you want to logout?</Text>
                )
            }}
            buttons={(onClose) => {
                return (
                    <>
                        <Button label="No" onClick={onClose} color="secondary" />
                        <AsyncGet
                            url="/account/logout"
                            permissionText={false}
                            onFetch={({ data }) => {
                                if (get(data, 'status') === 200) {
                                    dispatch(resetStore());
                                    navigate("/");
                                }
                            }}
                            render={({ fetching, loadFromAPI }) => (
                                <Button label="Yes" fetching={fetching} onClick={loadFromAPI} />
                            )}
                        />
                    </>
                )
            }}
        />
    );
};

export default Logout;